document.addEventListener('DOMContentLoaded',function(){
const body=document.body;
document.querySelectorAll('[data-cart-open]').forEach(function(b){b.addEventListener('click',function(){body.classList.add('drawer-open')})});
document.querySelectorAll('[data-cart-close]').forEach(function(b){b.addEventListener('click',function(){body.classList.remove('drawer-open')})});
const mobile=document.querySelector('[data-mobile-toggle]'),nav=document.querySelector('[data-mobile-nav]');
if(mobile&&nav) mobile.addEventListener('click',function(){nav.toggleAttribute('hidden')});

document.querySelectorAll('[data-product-gallery]').forEach(function(gallery){
  const main=gallery.querySelector('[data-main-product-image]');
  const thumbs=document.querySelectorAll('[data-thumb]');
  if(!main || !thumbs.length) return;
  thumbs.forEach(function(thumb,index){
    if(index===0) thumb.classList.add('is-active');
    thumb.addEventListener('click',function(){
      const url=thumb.getAttribute('data-image-url');
      if(!url) return;
      main.src=url;
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      thumbs.forEach(t=>t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });
});
});
document.addEventListener('click',function(e){
  const buy=e.target.closest('[data-buy-now]');
  if(!buy || buy.disabled) return;
  const form=buy.closest('form');
  if(!form) return;
  e.preventDefault();
  const id=form.querySelector('input[name="id"]');
  const quantity=form.querySelector('input[name="quantity"]');
  if(!id) return;
  const qty=Math.max(1,parseInt(quantity && quantity.value,10)||1);
  buy.disabled=true;
  const original=buy.textContent;
  buy.textContent='Procesando…';
  fetch('/cart/add.js', {
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body:JSON.stringify({items:[{id:Number(id.value),quantity:qty}]})
  }).then(function(r){
    if(!r.ok) throw new Error('No se pudo añadir el producto');
    return r.json();
  }).then(function(){
    window.location.href='/checkout';
  }).catch(function(){
    buy.disabled=false;
    buy.textContent=original;
    form.submit();
  });
});
